<script>
    export let view='ALL';
    export let name='';
</script>


<div class="btn-group mb-3" role="group">
    <input type="radio" class="btn-check" name="{name}" id="{name}1" autocomplete="off" bind:group={view} value='CHART'>
    <label class="btn btn-outline-secondary" for="{name}1"><i class="bi bi-bar-chart-line-fill"></i></label>
  
    <input type="radio" class="btn-check" name="{name}" id="{name}2" autocomplete="off" bind:group={view} value='TABLE'>
    <label class="btn btn-outline-secondary" for="{name}2"><i class="bi bi-table"></i></label>
  
    <input type="radio" class="btn-check" name="{name}" id="{name}3" autocomplete="off" bind:group={view} value='ALL'>
    <label class="btn btn-outline-secondary text-nowrap" for="{name}3"><i class="bi bi-bar-chart-line-fill me-1"></i><i class="bi bi-table"></i></label>
</div>
<style>
input,
label,
input:hover, 
input:active, 
input:focus,
label:focus,
label:active,
label:hover,
.btn:active,
.btn:hover,
.btn:focus
{
    outline:0px !important;
    -webkit-appearance:none;
    box-shadow: none !important;
}
</style>